<template>
  <div class="text-block big-card-block block-card card-border">
    <v-expansion-panel :value="panel" expand>
      <v-expansion-panel-content :lazy="lazyRendering">
        <template v-slot:header>
          <div class="block-card-title handle">
            <div class="title-icon">
              <v-icon class="white--text text-lg-2">shopping_cart</v-icon>
            </div>

            <h4>
              Order
              <v-icon
                v-if="errorsCount && errorsCount.errorsCount"
                color="error"
                style="margin-left: 4px"
                >error</v-icon
              >
              <span class="text--error" v-if="!validData"
                >(Invalid Card Data)</span
              >
            </h4>
          </div>
        </template>
        <form-validation v-model="errorsCount" v-if="validData">
          <div class="block-card-body">
            <label for="">Button Label</label>
            <vTextareaAutocomplete
              v-model="data.buttonTitle"
              :type="'textfield'"
              :validation-rules="[(v) => !!v || 'Button label is Required']"
              :counter="20"
            />

            <label for="">Extension Title</label>
            <vTextareaAutocomplete
              v-model="data.extensionTitle"
              :type="'textfield'"
              :validation-rules="[(v) => !!v || 'Title is Required']"
              :counter="1000"
            />

            <label for="">Extension Message</label>
            <vTextareaAutocomplete
              v-model="data.extensionMessage"
              :type="'textarea'"
              :validation-rules="[(v) => !!v || 'Message is Required']"
              :counter="1000"
            />

            <label for="">Cancel button label</label>
            <vTextareaAutocomplete
              v-model="data.cancelButtonLabel"
              :type="'textfield'"
              :validation-rules="[
                (v) => !!v || 'Cancel button label is Required',
              ]"
              :counter="1000"
            />

            <label for="">Cancel redirect block</label>
            <v-autocomplete
              :items="blocksList"
              v-model="data.cancelRedirectBlock"
              :error="!data.cancelRedirectBlock"
              :error-messages="
                !data.cancelRedirectBlock
                  ? 'Please select at least one block'
                  : ''
              "
              item-text="name"
              item-value="id"
              outline
              solo
              chips
            />

            <label><span class="text-bold">Or</span> Upload Your Image</label>
            <image-input
              :url="data.extensionImage"
              @onUploadComplete="handleImageUpload"
              @onFileRemove="handleImageRemove"
              types="image/jpg, image/jpeg, image/png"
              :maxFiles="1"
              :maxFilesize="5"
              :canRemove="true"
            />

            <label for="">Error message</label>
            <vTextareaAutocomplete
              v-model="data.errorMessage"
              :type="'textarea'"
              :validation-rules="[(v) => !!v || 'Error message is Required']"
              :counter="1000"
            />

            <label>Save Order Details To Attribute</label>
            <v-text-field
              v-model="data.save_to_attribute_cart"
              :error="!data.save_to_attribute_cart"
              :error-messages="
                !data.save_to_attribute_cart ? 'Attribute is Required' : ''
              "
              outline
            />

            <label>Save Order Cost To Attribute</label>
            <v-text-field
              v-model="data.save_to_attribute_cost"
              :error="!data.save_to_attribute_cost"
              :error-messages="
                !data.save_to_attribute_cost ? 'Attribute is Required' : ''
              "
              outline
            />

            <label for="">Branch</label>
            <vTextareaAutocomplete
              v-model="data.currentBranch"
              type="textfield"
              :validation-rules="[(v) => !!v || 'Branch is Required']"
              :counter="1000"
            />

            <label>Other Branches</label>
            <v-combobox
              v-model="data.branches"
              :items="[]"
              chips
              outline
              solo
              multiple
              class=""
            >
              <template v-slot:selection="data">
                <v-chip
                  :selected="data.selected"
                  class="rule-chip"
                  close
                  @input="removeItem(data.item)"
                >
                  <strong>{{ data.item }}</strong
                  >&nbsp;
                </v-chip>
              </template>
            </v-combobox>
          </div>

          <div class="mt-5" v-if="data.requestGetProducts">
            <h3 class="pl-4">Products API</h3>
            <json-header :headers="data.requestGetProducts.headers" />
            <json-request :data-object="data.requestGetProducts" />
          </div>

          <div class="mt-5" v-if="data.requestGetOrder">
            <h3 class="pl-4">Order Cart API</h3>
            <json-header :headers="data.requestGetOrder.headers" />
            <json-request :data-object="data.requestGetOrder" />
          </div>

          <div class="mt-5" v-if="data.requestSubmitOrder">
            <h3 class="pl-4">Order Submit API</h3>
            <json-header :headers="data.requestSubmitOrder.headers" />
            <json-request :data-object="data.requestSubmitOrder" />
          </div>
        </form-validation>
        <slot name="tail" />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
import common from "../../../../utils/common";
import FormValidation from "../FormValidation";
import imageInput from "./common-inner-blocks/image-uploader-dropzone";
import jsonHeader from "./json-api/json-header";
import jsonRequest from "./json-api/request";
export default {
  name: "CardOrder",
  components: {
    FormValidation,
    jsonHeader,
    jsonRequest,
    imageInput,
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
    index: {
      type: Number,
      default: () => {
        return 0;
      },
    },
    blocksList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    validData: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  data() {
    return {
      errorsCount: { errorsCount: 0 },
      lazyRendering: true,
      valid: true,
      panel: 1,
      common,
      autocompleteImageUrlValidationrRules: [
        (v) => !!v || "Image url is required",
      ],
    };
  },
  computed: {},
  watch: {
    errorsCount(val) {
      this.$emit("input", { errorsCount: val.errorsCount });
      this.data.errorsCount = val.errorsCount;
    },
  },
  mounted() {
    if (this.data.errorsCount !== undefined) {
      this.errorsCount = this.data.errorsCount;
    } else {
      // disabling Lazy rendering so we can grip errors count
      this.lazyRendering = false;
      setTimeout(() => {
        // then we turn it on again to keep the performance up
        this.lazyRendering = true;
      }, 1000);
    }
  },
  methods: {
    removeItem(item) {
      let index = this.data.branches.indexOf(item);
      this.data.branches.splice(index, 1);
    },

    handleImageUpload(e) {
      this.data.extensionImage = e[0].url;
    },
    handleImageRemove() {
      this.data.extensionImage = "";
    },
  },
};
</script>

<style scoped></style>
